var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.date != null)?_c('div',[_vm._v("\n  "+_vm._s(_vm._f("formatDate")(_vm.date))+"\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }